ContinuousDeliveryMetricsApp.Views.LastSevenDays = Backbone.View.extend({
    className: "col-lg-12",

    initialize: function() {
        var self = this;

        $('.last-seven-days-ibox').append(this.$el);

        $.ajax({
          url: '/assets/js/admin/continuous-delivery-metrics/03_templates/last-seven-days.html',
          success: function(extTemplate) {
            self.template = _.template(extTemplate);
            self.render();
            self.model.fetch();
          },
          cache: false
        });

        this.model.on('change', this.render, this);
    },

    render: function() {
        var model = this.model.toJSON();
        this.$el.html(this.template(model));

        if (model.lastSevenDays.length != 1 || model.lastSevenDays[0] != 'initial state') {
            $('.last-seven-days-ibox').toggleClass('sk-loading');
        }
    },

    close: function() {
        this.remove();
        this.unbind();
    }
});